import { matchPath, useLocation } from 'react-router-dom';

const pathsToHideSideBar = ['response/projects/:id/*'];

export function useShouldHideSideBar(): boolean {
  const { pathname: currentPath } = useLocation();

  function shouldHideSideBar(pathname: string) {
    return matchPath(pathname, currentPath);
  }

  return pathsToHideSideBar.some(shouldHideSideBar);
}
